import { Component } from "react";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null, info: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    this.setState({ info });
    console.error("Dashboard-Fehler:", error, info);
  }

  render() {
    if (this.state.error) {
      return (
        <div style={{ padding: 40, fontFamily: "system-ui, sans-serif", maxWidth: 700, margin: "60px auto" }}>
          <h2 style={{ color: "#D23B3B" }}>Etwas ist schiefgelaufen</h2>
          <p style={{ color: "#5B5B67" }}>
            Es gab einen Fehler beim Anzeigen dieses Bereichs. Bitte lade die Seite neu.
            Falls es wieder passiert, mach einen Screenshot von der Fehlermeldung unten (beide Kästen).
          </p>
          <pre style={{ background: "#F3F3F3", padding: 16, borderRadius: 8, overflowX: "auto", fontSize: 12, whiteSpace: "pre-wrap" }}>
            {String(this.state.error?.stack || this.state.error?.message || this.state.error)}
          </pre>
          {this.state.info ? (
            <pre style={{ background: "#EEEEF8", padding: 16, borderRadius: 8, overflowX: "auto", fontSize: 12, whiteSpace: "pre-wrap" }}>
              {this.state.info.componentStack}
            </pre>
          ) : null}
          <button
            onClick={() => window.location.reload()}
            style={{ padding: "10px 18px", background: "#01007F", color: "#fff", border: "none", borderRadius: 8, cursor: "pointer" }}
          >
            Seite neu laden
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
